import React, { useState } from "react";
import { Modal } from "antd";
import Button from "../components/shared/button";
import AllRemindersModal from "./allReminderModal";

const ReminderSet = ({
  remindersetOpen,
  setremindersetOpen,
  setallReminderModalOpen,
}) => {
  const handleOk = () => {
    setremindersetOpen(false);
  };

  const handleCancel = () => {
    setremindersetOpen(false);
  };

  const openallReminersModal = () => {
    setallReminderModalOpen(true);
    setremindersetOpen(false);
  };

  return (
    <>
      <Modal
        open={remindersetOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content flex flex-col items-center p-[34px] gap-[10px]">
          <img src="../../assets/icons/tick.png" alt="" />
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            Reminder has been set successfully!
          </h5>
          <Button
            text="See Reminders"
            className="button btn-blue !rounded-[39px] large mt-[25px] m-auto"
            height={45}
            width={176}
            onClick={openallReminersModal}
          />
        </div>
      </Modal>
      {/* <AllRemindersModal
        openAllRemindersModal={() => setallReminderModalOpen(true)}
      /> */}
    </>
  );
};

export default ReminderSet;
